export default "__VITE_ASSET__gi7KnGMf__"